export const CATEGORY_LABELS = {
  regular: '普通會員',
  youth: '青年會員',
  volunteer: '義工',
  senior: '長者',
};

export function membershipStatus(expiresOn) {
  if (!expiresOn) return { key: 'none', label: '無到期' };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expiry = new Date(`${expiresOn}T00:00:00`);
  const soon = new Date(today);
  soon.setDate(soon.getDate() + 30);
  if (expiry < today) return { key: 'expired', label: '已過期' };
  if (expiry <= soon) return { key: 'soon', label: '即將到期' };
  return { key: 'valid', label: '有效' };
}
